import React, { useEffect, useState } from "react";
import Quality_Plan_Form from "./quality_Plan_Form/Quality_Plan_Form";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Quality_Plan_table from "./quality_Plan_table/Quality_Plan_table";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/process_requirement/quality_control/Slice";
import { allVerificationType } from "../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";

function Quality_Plan() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const quality_control_plan = useSelector(
    (state) => state.quality_control_plan,
  );

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: quality_control_plan.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);
  const [showTable, setShowTable] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
                                    
  const haveReadPermission = permissions?.includes(FixIDS.quality_control_plan.List);
  const haveAddPermission = permissions?.includes(FixIDS.quality_control_plan.Add); //form

  
  return (
    <>
      <section className="Sample_Report">
        <div className="back_div">
          <Common_Back_Btn backText="Quality Control Plan" />
        </div>
        <div className="imperiality_Form_div">
          { haveAddPermission && <Quality_Plan_Form onProceed={() => setShowTable(true)} />}
        </div>

        {/* {showTable && ( */}
        <div className="imperiality_table_div">
          { haveReadPermission && <Quality_Plan_table quality_control_plan={quality_control_plan} currentPage={currentPage} setCurrentPage={setCurrentPage} fetchCustomers={fetchCustomers} />}
        </div>
        {/* )} */}
      </section>
    </>
  );
}

export default Quality_Plan;
